import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import AllActions from "../AllActions/AllActions";
import AllChances from "../AllChances/AllChances";
import AllVisits from "../AllVisits/AllVisits";
import { AllActivitiesTabStyle } from "./AllActivitiesTabStyle";

export const AllActivitiesTab = () => {
  return (
    <AllActivitiesTabStyle>
      <Tabs
        defaultActiveKey="actions"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="actions" title="کل فعالیت ها">
          <AllActions />
        </Tab>
        <Tab eventKey="history" title="کل فرصت ها">
          <AllChances />
        </Tab>
        <Tab eventKey="invoice" title="کل ویزیت ها">
          <AllVisits />
        </Tab>
      </Tabs>
    </AllActivitiesTabStyle>
  );
};
